import React from "react";
import EmployeeTable from "../components/EmployeeTable";

const EmployeeMaster = () => {

    return (
        <div>
            <EmployeeTable />
        </div>
    )

}

export default EmployeeMaster;